import React, { useState, useEffect } from 'react';
import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import axios from 'axios';
import FileListGrid from './FileListGrid';

const Files = ({
  folder = 'images',
  items = [],
  placeholder = '+ Upload',
  aspect = 1,
  crop = false,
  single = false,
  hasPublish = true,
  onChangeImage,
  onSelect,
  ...rest
}) => {
  const onChangeList = rest.onChange;
  const [fileList, setFileList] = useState(items);

  useEffect(() => {
    if (items && items.length) setFileList(items);
  }, [items]);

  const onChange = ({ fileList: newFileList }) => {
    newFileList = newFileList.map(file => {
      if (!file.url && file.status === 'done' && file.response) {
        file.url = file.response;
      }
      return file;
    });
    setFileList(newFileList);
    onChangeList(newFileList);
  };

  const onTogglePublic = updateFile => {
    const newFileList = fileList.map(file => {
      if (file.uid === updateFile.uid) file.selected = !file.selected;
      return file;
    });
    setFileList(newFileList);
    onChangeList(newFileList);
  };

  const onTogglePrimary = updateFile => {
    if (onChangeImage) return onChangeImage(updateFile);

    const newFileList = fileList.map(file => {
      if (file.uid === updateFile.uid) file.isPrimary = !file.isPrimary;
      return file;
    });
    setFileList(newFileList);
    onChangeList(newFileList);
  };

  const onRemove = file => {
    const newFileList = fileList.filter(item => item.uid !== file.uid);
    setFileList(newFileList);
    onChangeList(newFileList);
  };

  const onPreview = async file => {
    let src = file.url;
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const uploadFile = async ({ file, onSuccess, onError }) => {
    const fd = new FormData();
    fd.append('name', file.name);
    fd.append('image', file);
    fd.append('folder', folder);

    const result = await axios({
      method: 'post',
      url: '/api/upload/image',
      data: fd
    });

    if (result.status === 200) {
      const { data } = result;
      if (data.status === 'success') onSuccess(data.data);
      if (data.status === 'error') onError(data.message);
    }
  };

  return (
    <>
      <FileListGrid
        fileList={fileList}
        onPreview={onPreview}
        onRemove={onRemove}
        onTogglePublic={onTogglePublic}
        hasPublish={hasPublish}
        onChangeImage={onTogglePrimary}
        onSelect={onSelect}
      />
      {crop ? (
        <ImgCrop aspect={aspect}>
          <Upload
            listType="picture-card"
            fileList={fileList}
            onChange={onChange}
            onPreview={onPreview}
            customRequest={uploadFile}
            showUploadList={false}
          >
            {single && fileList.length === 1 ? null : placeholder}
          </Upload>
        </ImgCrop>
      ) : (
        <Upload
          listType="picture-card"
          fileList={fileList}
          onChange={onChange}
          onPreview={onPreview}
          customRequest={uploadFile}
          showUploadList={false}
        >
          {single && fileList.length === 1 ? null : placeholder}
        </Upload>
      )}
    </>
  );
};

export default Files;
